/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_CroatianInputs */

const en_speechmatics_target_language_croatian = /** @type {(inputs: Speechmatics_Target_Language_CroatianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Croatian`)
};

const fr_speechmatics_target_language_croatian = /** @type {(inputs: Speechmatics_Target_Language_CroatianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Croate`)
};

const de_speechmatics_target_language_croatian = /** @type {(inputs: Speechmatics_Target_Language_CroatianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kroatisch`)
};

const it_speechmatics_target_language_croatian = /** @type {(inputs: Speechmatics_Target_Language_CroatianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`croato`)
};

const ru_speechmatics_target_language_croatian = /** @type {(inputs: Speechmatics_Target_Language_CroatianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`хорватский`)
};

const es_speechmatics_target_language_croatian = /** @type {(inputs: Speechmatics_Target_Language_CroatianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`croata`)
};

const zh_cn2_speechmatics_target_language_croatian = /** @type {(inputs: Speechmatics_Target_Language_CroatianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`克罗地亚语`)
};

const ja_speechmatics_target_language_croatian = /** @type {(inputs: Speechmatics_Target_Language_CroatianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クロアチア語`)
};

const hi_speechmatics_target_language_croatian = /** @type {(inputs: Speechmatics_Target_Language_CroatianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्रोएशियाई`)
};

const pt_pt2_speechmatics_target_language_croatian = /** @type {(inputs: Speechmatics_Target_Language_CroatianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`croata`)
};

/**
* | output |
* | --- |
* | "Croatian" |
*
* @param {Speechmatics_Target_Language_CroatianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_croatian = /** @type {((inputs?: Speechmatics_Target_Language_CroatianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_CroatianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_croatian(inputs)
	if (locale === "de") return de_speechmatics_target_language_croatian(inputs)
	if (locale === "it") return it_speechmatics_target_language_croatian(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_croatian(inputs)
	if (locale === "es") return es_speechmatics_target_language_croatian(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_croatian(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_croatian(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_croatian(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_croatian(inputs)
	return en_speechmatics_target_language_croatian(inputs)
});